import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
    const { user, login, loading } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [busy, setBusy] = useState(false);
    const nav = useNavigate();

    if (loading) return <div className="pt-40 text-center italic text-lg text-[rgb(var(--ink-2))]">…</div>;
    if (user) return <Navigate to="/admin" replace />;

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await login(email.trim().toLowerCase(), password);
            toast.success("Welcome back.");
            nav("/admin");
        } catch (err) {
            const detail = err?.response?.data?.detail;
            toast.error(typeof detail === "string" ? detail : "Login failed");
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center px-6 py-24" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <p className="text-[11px] tracking-[0.32em] uppercase font-bold text-[rgb(var(--gold))]">
                    The Study / Admin
                </p>
                <h1 className="mt-4 text-3xl md:text-4xl font-bold tracking-tight text-[rgb(var(--teal))]">
                    Sign in.
                </h1>
                <p className="mt-3 italic text-lg text-[rgb(var(--ink-2))]">
                    Come write something honest.
                </p>

                <form onSubmit={submit} className="mt-12 space-y-8" data-testid="admin-login-form">
                    <div>
                        <label className="text-[10px] tracking-[0.28em] uppercase font-bold text-[rgb(var(--gold))]">
                            Email
                        </label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="input-underline mt-2"
                            data-testid="admin-login-email"
                        />
                    </div>
                    <div>
                        <label className="text-[10px] tracking-[0.28em] uppercase font-bold text-[rgb(var(--gold))]">
                            Password
                        </label>
                        <input
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="input-underline mt-2"
                            data-testid="admin-login-password"
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={busy}
                        className="btn-primary disabled:opacity-50"
                        data-testid="admin-login-submit"
                    >
                        {busy ? "Signing in…" : "Sign in"}
                        <span>→</span>
                    </button>
                </form>
            </div>
        </div>
    );
}
